import { render, staticRenderFns } from "./PhaenAufgabenSearch.vue?vue&type=template&id=687136fc&"
import script from "./PhaenAufgabenSearch.vue?vue&type=script&lang=ts&"
export * from "./PhaenAufgabenSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports